import { z } from 'zod';

import { PaginationSchema } from '../../../pagination.js';

const taxonomySlug = z
  .string()
  .trim()
  .min(1)
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const RegisterProductTypeBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  slug: taxonomySlug,
});

export const RegisterProductTypeResponseSchema = z.object({
  productTypeId: z.uuid(),
});

export const UpdateProductTypeBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    slug: taxonomySlug.optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const ArchiveProductTypeBodySchema = z.object({
  reason: z.string().trim().max(500).optional(),
});

export const ListProductTypesQuerySchema = PaginationSchema;

export const ProductTypeListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const ListProductTypesResponseSchema = z.object({
  items: z.array(ProductTypeListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type RegisterProductTypeBody = z.infer<typeof RegisterProductTypeBodySchema>;
export type RegisterProductTypeResponse = z.infer<typeof RegisterProductTypeResponseSchema>;
export type UpdateProductTypeBody = z.infer<typeof UpdateProductTypeBodySchema>;
export type ArchiveProductTypeBody = z.infer<typeof ArchiveProductTypeBodySchema>;
export type ListProductTypesQuery = z.infer<typeof ListProductTypesQuerySchema>;
export type ListProductTypesResponse = z.infer<typeof ListProductTypesResponseSchema>;
